import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormField, FormItem, FormLabel, FormMessage } from "~/atoms/form";
import { useTiers } from "~/api/swr/useTiers";
import { ControlledCombobox } from "~/molecules/ControlledCombobox";
import { type DocumentEditFormValues } from "~/hooks/useDocumentEditForm";
import { mapTierOptions } from "~/helpers/tier";

export const DocumentTierField = () => {
  const { t } = useTranslation();
  const { data: tiers } = useTiers();
  const form = useFormContext<DocumentEditFormValues>();

  return (
    <FormField
      control={form.control}
      name="tierId"
      render={({ field }) => (
        <FormItem>
          <FormLabel>{t(($) => $.commons.document.tier)}</FormLabel>
          <ControlledCombobox
            value={field.value}
            options={mapTierOptions(tiers, t) ?? []}
            onChange={field.onChange}
            placeholder={t(($) => $.commons.customSelect.selectTier)}
          />
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
